// 每日小時成本
import { lowerFirst } from 'lodash';
import * as types from '../actionType';

let initState = {
};

function AccumulateCostChart(state = initState, action) {
  switch (action.type) {
      case types.ACCUMULATE_COST_CHART_SUCCESS:{
          console.log(action.result);
        return action.result;
      }
      default:
        return state;
  }
}


export default AccumulateCostChart;